import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { createStylesContext } from '@chakra-ui/react';
const [SidebarStylesProvider, useSidebarStyles] = createStylesContext('Sidebar');
export { SidebarStylesProvider, useSidebarStyles };
const SidebarNestContext = createContext(undefined);
export const SidebarNestProvider = ({ children, nested }) => {
    return (_jsx(SidebarNestContext.Provider, { value: { nested }, children: children }));
};
export const useSidebarNestContext = () => {
    const context = useContext(SidebarNestContext);
    if (!context) {
        return {
            nested: false,
        };
    }
    return context;
};
const SidebarContext = createContext(undefined);
export const SidebarProvider = ({ children, reduceMotion = false, }) => {
    return (_jsx(SidebarContext.Provider, { value: { reduceMotion }, children: children }));
};
export const useSidebarContext = () => {
    const context = useContext(SidebarContext);
    if (!context) {
        return {
            reduceMotion: false,
        };
    }
    return context;
};
